<template>
    <div class="container pt-4 mb-5">
        <kt-row style="background-color: #f1f1f1" class="p-4 shadow-sm">
            <kt-col lg="5" md="5" xs="12">
                <img v-if="form_data.has_image === true"
                     width="100"
                     height="100"
                     :src="form_data.profile_image"
                     alt="profile"
                >
                <img v-else
                     width="100"
                     height="100"
                     src="../assets/avatar.png"
                     :alt="form_data.pay_link_title"
                >
                <p style="width:auto;display:inline-block;" class="pl-2">
                    {{ $t('pardakht_shakhsi.form.label.user_name') }}<br>
                    <span style="font-size:1.5rem;color:#00bea5">
                        {{ form_data.pay_link_title }}
                    </span>
                </p>
            </kt-col>
            <kt-col lg="3" md="3" xs="12" class="mt-4">
                <p style="width:auto;display:inline-block;">
                    {{ $t('pardakht_shakhsi.form.label.transaction_code') }}<br>
                    <span style="font-size:1.5rem;color:#00bea5">
                        {{ form_data.tracking_code }}
                    </span>
                </p>
            </kt-col>
            <kt-col lg="2" md="2" xs="6" class="mt-4">
                <p style="width:auto;display:inline-block;">
                    {{ $t('pardakht_shakhsi.form.label.payer_wage') }}<br>
                    <span style="font-size:1.5rem;color:#00bea5">
                        {{ form_data.payer_wage + ' ' + $t('currency.rial') }}
                    </span>
                </p>
            </kt-col>
            <kt-col lg="2" md="2" xs="6" class="mt-4">
                <p style="width:auto;display:inline-block;">
                    {{ $t('pardakht_shakhsi.form.label.pay_amount') }}<br>
                    <span style="font-size:1.5rem;color:#00bea5">
                        {{ form_data.pay_amount + ' ' + $t('currency.rial') }}
                    </span>
                </p>
            </kt-col>
        </kt-row>
        <kt-row class="p-4 bg-white row-eq-height">
            <kt-col lg="6" md="6" xs="12">
                <div class="card">
                    <div class="card-header text-center">
                        {{ $t('pardakht_shakhsi.form.label.payer_info') }}
                    </div>
                    <div class="card-body">
                        <kt-form-group v-if="form_data.payer_name !== null">
                            <kt-form-label>
                                {{ $t('pardakht_shakhsi.form.label.full_name') }}
                            </kt-form-label>
                            <div class="form-input form-control">
                                {{ form_data.payer_name }}
                            </div>
                        </kt-form-group>
                        <kt-form-group>
                            <kt-form-label>
                                {{ $t('pardakht_shakhsi.form.label.phone_number') }}
                            </kt-form-label>
                            <div class="form-input form-control">
                                {{ form_data.payer_phone_number }}
                            </div>
                        </kt-form-group>
                        <kt-form-group v-if="form_data.payer_email !== null">
                            <kt-form-label>
                                {{ $t('pardakht_shakhsi.form.label.email') }}
                            </kt-form-label>
                            <div class="form-input form-control text-right ltr" >
                                {{ form_data.payer_email }}
                            </div>
                        </kt-form-group>
                        <kt-form-group v-if="form_data.payer_description !== null">
                            <kt-form-label>
                                {{ $t('pardakht_shakhsi.form.label.description') }}
                            </kt-form-label>
                            <div class="form-input form-control" style="height:auto;">
                                {{ form_data.payer_description }}
                            </div>
                        </kt-form-group>
                        <kt-form-action class="mt-2 mb-2 text-center">
                            <kt-button
                                    class="m-2 form-submit p-3 pr-5 pl-5"
                                    size="md"
                                    variant="warning"
                                    type="button"
                                    @click="submit(0)"
                                    v-bind:wide="true"
                                    id="back_btn"
                            >
                                {{ $t('pardakht_shakhsi.form.btn.back_and_edit') }}
                            </kt-button>
                        </kt-form-action>
                    </div>
                </div>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" class="bg-light">
                <div class="mt-5">
                    <div class="text-center mb-4" style="color:#00bea5;font-size:1.5rem">
                        {{ $t('pardakht_shakhsi.form.label.fast_pay') }}
                    </div>
                    <kt-form-action class="mt-2 mb-2 text-center">
                        <kt-button
                                class="m-2 form-submit p-3 pr-5 pl-5"
                                size="md"
                                variant="success"
                                type="button"
                                @click="submit(1)"
                                v-bind:wide="true"
                                id="pay_btn"
                        >
                            {{ $t('pardakht_shakhsi.form.btn.online_payment') }}
                            <i class="fa fa-credit-card ml-3"></i>
                        </kt-button>
                    </kt-form-action>
                </div>
            </kt-col>
        </kt-row>
    </div>
</template>

<script>
    export default {
        name: "checkoutForm",
        props: {
            submit: {
                default: () => {},
                type: Function
            },
            form_data: {
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style scoped>
    .user-img img {
        width: 100px;
    }
    .paystar-logo img {
        width: 100%;
    }


    @media screen and (max-width: 440px){
        .user-img img {
            width: 100%;
        }
    }
    @media screen and (max-width: 767px){
        .paystar-logo {
            padding-top: 10px;
            border-top: #00bea5 2px dashed;
        }
        .paystar-logo img {
            width: 150px;
        }
    }
</style>
